<div class="btn-group">
  <button
    type="button"
    class="btn btn-secondary dropdown-toggle btn-sm ml-xl-5 pl-3 py-2 springBtn overflow-ellipsis ws-collapse"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
  >
    <span> {{ selected ?? ("SELECT_SITE" | translate) }} &nbsp; </span>
    <img class="arrow-down" src="assets/svg/ico-chevron-down-outline.svg" />
  </button>
  <div id="site-toggle" class="dropdown-menu dropdown-menu-right">
    <div class="triangle-with-shadow">
      <div class="rectangle">
        <div class="inner overflow-ellipsis ws-collapse">
          <span> {{ selected ?? ("SELECT_SITE" | translate) }} &nbsp; </span>
          <img
            src="assets/svg/ico-chevron-down-outline.svg"
            class="arrow-down"
          />
        </div>
      </div>
    </div>
    <div *ngFor="let item of sites">
      <button
        class="dropdown-item"
        type="button"
        (click)="onSelect(item?.siteId, item?.siteName, item?.siteTimeZone, item?.commonAccessControl)"
      >
        <app-with-tooltip [showHelpCursor]="true">{{
          item?.siteName
        }}</app-with-tooltip>
      </button>
    </div>
  </div>
</div>
